if (!customElements.get('fcp-warranty-promo')) {
  customElements.define('fcp-warranty-promo', class extends HTMLElement {
    connectedCallback() {
      this.form = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"] form[data-type="add-to-cart-form"]`);
      this.onVariantChange = (event) => {
        this.hidden = !this.dataset.eligibleSkus.split(',').includes(event.detail?.variant?.sku);
      };
      this.form?.addEventListener('variant:change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.onVariantChange);
    }
  });
}
